<section
  class="ps-under-construction"
  role="region"
  aria-label="We're Building This Page"
  data-cy="under-construction"
>
  <div class="ps-under-construction-hero" data-cy="under-construction-hero">
    <img
      class="ps-under-construction-illustration"
      src="assets/images/under-construction.svg"
      alt="Illustration of builders working on a web page under construction"
      loading="lazy"
      decoding="async"
      data-cy="under-construction-illustration"
    />
  </div>
  <h1
    class="ps-under-construction-heading"
    data-cy="under-construction-heading"
  >
    We're Building This Page
  </h1>
  <p
    class="ps-under-construction-description"
    data-cy="under-construction-description"
  >
    Hang tight! Our team is working on this page and it will be ready soon. You
    can head back home or continue using the legacy version.
  </p>
  <div
    class="ps-under-construction-actions"
    data-cy="under-construction-actions"
  >
    <ps-button
      type="button"
      variant="filled"
      color="primary"
      size="md"
      ariaLabel="Return to Home"
      data-cy="under-construction-return-home"
      (clicked)="onHome()"
    >
      <ps-icon name="house" />
      Return to Home
    </ps-button>
    <ps-button
      type="button"
      variant="outline"
      color="primary"
      size="md"
      ariaLabel="Go to Legacy Layout"
      data-cy="under-construction-legacy-layout"
      (clicked)="onLegacy()"
    >
      <ps-icon name="arrow-rotate-left" />
      Go to Legacy Layout
    </ps-button>
  </div>
</section>
